<template>
  <v-layout column style="height: calc(100vh - 76px); overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin nonPrint mx-4" style="margin-top: 10px; flex: 0 0 auto;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>รายละเอียดข้อมูล {{data_aed.address_name}}</v-toolbar-title>
    </v-toolbar>

    <v-layout row wrap justify-end style="margin-top: 0px; flex: 0 0 auto;" class="nonPrint">
      <div class="nonPrint positionPrint" >
        <v-tooltip bottom v-if="(data_aed.company_id == IdCompany && typeCompany == 'partner') || typeCompany == 'owner'">
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" outlined fab small color="#a80f00" @click="GetListHistory()" v-on="on">
              <v-icon>far fa-list-alt</v-icon>
            </v-btn>
          </template>
          <span class="nonPrint">ประวัติการใช้งาน</span>
        </v-tooltip>

        <v-tooltip bottom v-if="(data_aed.company_id == IdCompany && typeCompany == 'partner') || typeCompany == 'owner'">
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" outlined fab small color="#a80f00" @click="issueOpen()" v-on="on">
              <v-icon>fas fa-exclamation-circle</v-icon>
            </v-btn>
          </template>
          <span class="nonPrint">การแจ้งปัญหา</span>
        </v-tooltip>

        <v-tooltip bottom >
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" outlined fab small color="#a80f00" @click="print()" v-on="on">
              <img :src="BASE_URL + 'static/iconButton/printing.png'" alt="" width="25px">
            </v-btn>
          </template>
          <span class="nonPrint">Print</span>
        </v-tooltip>
      </div>
    </v-layout>

    <v-layout column align-center class="nonPrint scrollable-content">
      <v-layout wrap justify-center align-center class="border-images">
        <v-carousel
          cycle
          height="200"
          hide-delimiter-background
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(slide, i) in data_aed.list_picture"
            :key="i"
          >
            <img :src="API_BACKEND + '/v1/thumbnail' + slide.picture_path" height="200">
          </v-carousel-item>
        </v-carousel>
      </v-layout>
      <v-layout row wrap style="padding: 10px; margin-top: 5px;">
        <v-flex xs12 sm12 md12 lg12 xl12>
          <h2>{{data_aed.address_name}}</h2>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12 >
          <div style="text-align: left; background: #e2e2e2 !important; border-radius: 6px;padding: 10px; margin-bottom: 10px;">
            <span>{{data_aed.address_detail? data_aed.address_detail:'-'}}</span>
          </div>
        </v-flex>
      </v-layout>

      <table class="customers Kanit" style="width: 600px;" v-if="data_aed">
        <tr>
          <th class="div_infor_header">ตำแหน่ง:</th>
          <td class="div_infor">lat: {{(data_aed.location && data_aed.location.latitude) ? data_aed.location.latitude : '-'}} <br/>lon: {{(data_aed.location && data_aed.location.longitude) ? data_aed.location.longitude : '-'}}</td>
        </tr>
        <tr>
          <th class="div_infor_header">วัน เวลาเปิด-ปิด:</th>
          <td class="div_infor">
            <div v-for="(item,index) in dayArray" style="margin: 8px 0;">
              <v-layout row wrap>
                <v-flex xs3 sm3 md3 lg3 xl3 style="padding-left: 10px;">
                  <span style="font-weight: 600 !important;">{{item.th}}</span>
                </v-flex>

                <v-flex xs8 sm8 md8 lg8 xl8 >
                  <span style="">{{data_aed.opening_time ? CloseorOpen(DayData(data_aed.opening_time.openday_detail, item.en)) : '-'}}
                  </span>
                </v-flex>
              </v-layout>
            </div>
            <br v-if="data_aed.opening_time && data_aed.opening_time.public_holidays == 'true'">
            <span style="font-weight: 600 !important; " v-if="data_aed.opening_time && data_aed.opening_time.public_holidays == 'true'">* ปิดทุกวันหยุดนักขัตฤกษ์</span>
          </td>
        </tr>
        <tr>
          <th class="div_infor_header">วันหมดอายุ Pad:</th>
          <td class="div_infor">{{(data_aed.pad_expire !=null && data_aed.pad_expire != '')? data_aed.pad_expire: '-'}}</td>
        </tr>
        <tr>
          <th class="div_infor_header">วันหมดอายุแบตเตอร์รี่:</th>
          <td class="div_infor">{{(data_aed.battery_expire !=null && data_aed.battery_expire != '')? data_aed.battery_expire: '-'}}</td>
        </tr>
      </table>

      <table class="customers Kanit" style="margin-top: 10px;width: 600px; margin-bottom: 20px;" v-if="data_aed">
        <tr>
          <th class="div_infor_header">ผู้ทำการเพิ่มข้อมูล:</th>
          <td class="div_infor">{{data_aed.who_add_aed}} </td>
        </tr>
        <tr>
          <th class="div_infor_header">หน่วยงานเจ้าของเครื่อง:</th>
          <td class="div_infor">{{data_aed.company_owner_name? data_aed.company_owner_name: '-'}}</td>
        </tr>
        <tr>
          <th class="div_infor_header">หน่วยงานดูแลเครื่อง:</th>
          <td class="div_infor">{{data_aed.company_maintenance_name? data_aed.company_maintenance_name: '-'}}</td>
        </tr>
        <tr>
          <th class="div_infor_header">Serial Number:</th>
          <td class="div_infor">{{data_aed.serial_number? data_aed.serial_number: '-'}}</td>
        </tr>
        <tr>
          <th class="div_infor_header">QR code:</th>
            <td class="div_infor" v-if="data_aed.qrcode_id">
              <qrcode :value="API_FRONTEND + 'AEDQRcode/' + data_aed.qrcode_id" style="width: 150px;"></qrcode>
            </td>
          <td class="div_infor" v-else>-</td>
        </tr>
      </table>
    </v-layout>

    <!-- Fixed Delete Button -->
    <v-layout justify-center align-center class="nonPrint" :class="{ 'fixed-delete-button' : (data_aed.company_id == IdCompany && typeCompany == 'partner') || typeCompany == 'owner'}">
      <v-btn rounded color="#a80f00" style="text-transform: none; color: white;" v-if="(data_aed.company_id == IdCompany && typeCompany == 'partner') || typeCompany == 'owner'" @click="deleteAED()">
        ลบเครื่อง
      </v-btn>
    </v-layout>

    <!-- pdf -->
    <div class="pdfSection" style="margin-top: 30px; height: 100vh;">
      <div style="height: 100vh;">
        <div class="pageBreak" style="justify-content: center; display: grid;">
          <p style="margin-top: 30px;font-weight: bold;font-size: 30px">ข้อมูลเครื่อง AED</p>
          <div>
            <img v-for="slide in data_aed.list_picture" :src="API_BACKEND + '/v1' + slide.picture_path" height="200" style="margin-right: 10px;">
          </div>
          <h1>{{data_aed.address_name}}</h1>
          <div style="text-align: left; background: #e2e2e2 !important; border-radius: 6px;padding: 10px; margin-bottom: 10px;">
            <span>{{data_aed.address_detail}}</span>
          </div>

          <table class="customers Kanit" style="width: 600px;height: auto;" v-if="data_aed">
            <!-- {{data_aed.location.latitude}} -->
            <tr>
              <th class="div_infor_header">ตำแหน่ง:</th>
              <td class="div_infor">lat: {{(data_aed.location && data_aed.location.latitude != null && data_aed.location.latitude != '')? data_aed.location.latitude: '-'}} <br/>lon: {{(data_aed.location && data_aed.location.longitude !=null && data_aed.location.longitude != '')? data_aed.location.longitude: '-'}}</td>
            </tr>
            <tr>
              <th class="div_infor_header">วัน เวลาเปิด-ปิด:</th>
              <td class="div_infor"><!-- {{checkOpentime(data_aed.opening_time)}} เวลา {{data_aed.opening_time.open_time}}-{{data_aed.opening_time.close_time}} น. -->
                <div v-for="(item,index) in dayArray" style="margin: 8px 0;">
                  <v-layout row wrap>
                    <v-flex xs3 sm3 md3 lg3 xl3 style="padding-left: 10px;">
                      <span style="font-weight: 600 !important;">{{item.th}}</span>
                    </v-flex>

                    <v-flex xs8 sm8 md8 lg8 xl8 >
                      <span style="">{{data_aed.opening_time ? CloseorOpen(DayData(data_aed.opening_time.openday_detail, item.en)) : '-'}}
                      </span>
                    </v-flex>
                  </v-layout>
                </div>
                <br v-if="data_aed.opening_time && data_aed.opening_time.public_holidays == 'true'">
                <span style="font-weight: 600 !important; " v-if="data_aed.opening_time && data_aed.opening_time.public_holidays == 'true'">* ปิดทุกวันหยุดนักขัตฤกษ์</span>
              </td>
            </tr>
            <tr>
              <th class="div_infor_header">วันหมดอายุ Pad:</th>
              <td class="div_infor">{{(data_aed.pad_expire !=null && data_aed.pad_expire != '')? data_aed.pad_expire: '-'}}</td>
            </tr>
            <tr>
              <th class="div_infor_header">วันหมดอายุแบตเตอร์รี่:</th>
              <td class="div_infor">{{(data_aed.battery_expire !=null && data_aed.battery_expire != '')? data_aed.battery_expire: '-'}}</td>
            </tr>
          </table>

          <table class="customers Kanit" style="margin-top: 10px;width: 600px;height: auto;" v-if="data_aed">
            <tr>
              <th class="div_infor_header">ผู้ทำการเพิ่มข้อมูล:</th>
              <td class="div_infor">{{data_aed.who_add_aed}} </td>
            </tr>
            <tr>
              <th class="div_infor_header">หน่วยงานเจ้าของเครื่อง:</th>
              <td class="div_infor">{{data_aed.company_owner_name? data_aed.company_owner_name: '-'}}</td>
            </tr>
            <tr>
              <th class="div_infor_header">หน่วยงานดูแลเครื่อง:</th>
              <td class="div_infor">{{data_aed.company_maintenance_name? data_aed.company_maintenance_name: '-'}}</td>
            </tr>
            <tr>
              <th class="div_infor_header">Serial Number:</th>
              <td class="div_infor">{{data_aed.serial_number? data_aed.serial_number: '-'}}</td>
            </tr>
            <tr>
              <th class="div_infor_header">QR code:</th>
            <td class="div_infor" v-if="data_aed.qrcode_id">
                <qrcode :value="data_aed.qrcode_id" style="width: 150px;"></qrcode>
              </td>
              <td class="div_infor" v-else>-</td>
            </tr>
          </table>
        </div> 
      </div>
    </div>
  </v-layout>
</template>
<script>
import Vue from 'vue'
import ImageSlider from '@gaiaz/vue-image-slider'
import '@gaiaz/vue-image-slider/dist/image-slider.css'
import { Carousel, Slide } from 'vue-carousel'
import { Decode } from '@/services'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_BACKEND: process.env.API_BACKEND,
      API_FRONTEND: process.env.API_FRONTEND,
      aed_id: '',
      typeCompany: 'partner',
      IdCompany: '',
      data_aed: {},
      dayArray: [{th: 'วันจันทร์', en:'monday'}, {th: 'วันอังคาร', en:'tuesday'}, {th: 'วันพุธ', en:'wednesday'}, {th: 'วันพฤหัสบดี', en:'thursday'}, {th: 'วันศุกร์', en:'friday'}, {th: 'วันเสาร์', en:'saturday'}, {th: 'วันอาทิตย์', en:'sunday'}]
    }
  },
  components: {
    Carousel,
    Slide
  },
  created () {
    this.aed_id = this.$route.query.id
    this.typeCompany = this.$store.state.key_object.typeCompany
    // console.log(this.authen)
    this.IdCompany = this.$store.state.key_object.idCompany
    this.getData()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    DayData (dayDetail,nameDay) {
      if (!dayDetail || !dayDetail[nameDay]) {
        return { time_open_type: '-' }
      }
      return dayDetail[nameDay]
    },
    CloseorOpen (state) {
      if (!state) {
        return '-'
      }
      if (state.time_open_type == 'close') {
        return 'ปิดทำการ'
      } else if (state.time_open_type == 'sometime') {
        return 'เปิดเวลา ' + state.open_time + ' - ' + state.close_time
      } else if (state.time_open_type == 'alltime') {
        return 'เปิดตลอดเวลา '
      }
      return '-'
    },
    // OpenTime (detail) {
    //   return detail.open_time + ' - ' + detail.close_time
    // },
    issueOpen () {
      this.$router.push('/information/issueAED?aed_id=' + this.aed_id)
    },
    GetListHistory () {
      this.$router.push('/information/historyAED?page=1&aed_id=' + this.aed_id)
    },
    print () {
      window.print()
    },
    routeinfo () {
      // history.go(-1)
      this.$router.back()
      // window.history.back();
      // location.reload();
    },
    getData () {
      this.$api.getDataAED(this.aed_id).then((response) => {
        // console.log(response.data.data)
        this.data_aed = response.data.data
      })
    },
    deleteAED () {
      var body = {
        aed_id: this.aed_id
      }
      this.$swal({
        title: 'คุณต้องการลบ AED เครื่องนี้ใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          popup: 'custom-swal-font'
        },
      }).then((result) => {
        if (result.value) {
          this.$api.deleteAED(body).then((response) => {
            // console.log(response.data.data)
            this.$swal('', 'เครื่อง AED ถูกลบแล้ว', 'success')
            this.routeinfo()
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    checkOpentime (opening_time) {
      if (opening_time.open_type == 'someday'){
        var toggle = false;
        var listDay = []
        var item = 0
        for (item in opening_time.open_day) {
          listDay.push(this.dayOfWeekAsInteger(opening_time.open_day[item]))
        }
        listDay.sort()
        var display = ''

        for (var i=0; i <= listDay.length ; i++){
          if (i == 0) {
            display = '' + listDay[0]
          } else if (i == listDay.length-1) {
            if (listDay[i-1] == listDay[i]-1) {
              display = display + "-" + listDay[i]
            } else {
              display = display + "," + listDay[i]
            }
          } else if (i == listDay.length) {
            return this.thaiday(display)
          } else if (listDay[i-1] == listDay[i]-1){
          } else if (i == 1) {
            display = display + "," + listDay[i]

          } else {
            display = display + "-" + listDay[i-1] + "," + listDay[i]
          }
        }
      } else {
        return 'ทุกวัน'
      }
    },
    thaiday (day) {
      return day.replace('1', 'วันจันทร์').replace('2', 'วันอังคาร').replace('3', 'วันพุธ').replace('4', 'วันพฤหัสบดี').replace('5', 'วันศุกร์').replace('6', 'วันเสาร์').replace('7', 'วันอาทิตย์')
    },
    dayOfWeekAsInteger(day) {
      return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].indexOf(day) + 1
    }
  }
}
</script>
<style media="screen" scoped>
  .fonts {
    font-family: 'Sarabun', sans-serif !important;
  }
  .positionPrint {
    width: 70vw;
    margin-left: 30vw;
    text-align: right;
    padding-right: 16vw;
  }

  .customers {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
  }

  .customers td, .customers th {
    border: 1px solid #ddd;
    padding: 8px;
  }


  .customers th {
    background-color: #a80d00;
    color: white;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 10px;
    /*text-align: right !important;*/
  }
  .customers td {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;
    text-align: left !important;
    width: 400px;
  }

  @media screen {
    #PDF {
      height: 100vh !important;
      overflow: scroll;
    }
    .pdfSection {
      display: none;
    }
  }
  @media print {
    .pdfSection {
      width: 100%;
      height:100%;
      position:absolute;
      top:0px;
      bottom:0px;
      margin: auto;
      margin-top: 0px !important;
      display: show;
      -webkit-print-color-adjust: exact; 
    }
    .nonPrint {
      display: none;
    }
    #PDF {
      height: 100vh;
      overflow: hidden;
    }
    /*.pageBreak { page-break-inside:always; }*/
    .pageBreak * {
    /*  page-break-after:avoid;
      page-break-before:avoid;*/
    }
  }
  >>>.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 33px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }
  .fonts-icons {
    font-size: 55px !important;
  }
  .border-images {
    border-color: #a80e00 !important;
    border-style: solid !important;
    width: 450px !important;
    border-radius: 20px !important;
    margin-bottom: 20px !important;
  }
  >>>.accent {
    background-color: #8c0c00 !important;
  }

  .div_infor_button {
    height: 40px !important;
    width: 400px !important;
    margin-top: 30px !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
  }
  .div_infor_button_help {
    background-color: white !important;
    height: 40px !important;
    width: 100% !important;
    margin-top: 30px !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
  }
  >>>.white {
    width: 100% !important;
    background-color: #fff!important;
    border-color: #fff!important;
  }
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
    color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }

  .div_infor_header {
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 10px;
    font-size: 15px;
    padding-right: 10px;
    border: 1px solid #a80d00 !important;
  }
  .div_infor {
    width: 20vw;
    /*border: solid 1px #a80d00;*/
    text-align: left;
    padding-left: 10px;
    font-size: 15px;
    padding-left: 10px;
    border: 1px solid #a80d00 !important;
  }

  .tableInfor {
    justify-content: center;
    display: inline-table;
    width: 40vw;
  }

  .Kanit{
    font-family: 'Kanit', sans-serif !important;
  }

  .scrollable-content {
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
    padding-top: 20px;
    padding-bottom: 20px;
    align-items: center !important;
  }

  .fixed-delete-button {
    flex: 0 0 auto;
    padding-top: 10px;
    background-color: white;
    border-top: 1px solid #e0e0e0;
  }
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_aed.vue